import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
	badge: {
		display: "inline-block",
		padding: "2px 8px",
		fontSize: "11px",
		fontWeight: 700,
		letterSpacing: "0.05em",
		color: "#6b7280",
		backgroundColor: "#e5e7eb",
		borderRadius: "10px",
		textTransform: "uppercase",
	},
}));

const PausedBadge = () => {
	const { classes } = useStyles();
	return <span className={classes.badge}>Paused</span>;
};

export default PausedBadge;
